import React, { useEffect, useState, memo } from 'react';
export const UrgencyBar = memo(function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full" data-id="element-197">
      <a href="#compra" aria-label="Ir a la oferta especial" className="block w-full bg-gradient-to-r from-blue-700 via-blue-600 to-blue-700 text-white py-1.5 px-4 text-center shadow-md hover:opacity-90 transition-opacity cursor-pointer" data-id="element-198">
        <div className="max-w-screen-xl mx-auto flex flex-col items-center leading-snug" data-id="element-199">
          <span className="md:text-[14px] font-black uppercase tracking-wide whitespace-nowrap text-[9px]" data-id="element-200">
            ⚡{' '}
            <span className="text-yellow-300" data-id="element-201">
              Megapack Electricista en Casa
            </span>{' '}
            — Precio especial HOY:{' '}
            <span className="bg-blue-900/40 px-2 py-0.5 rounded text-yellow-300 tracking-widest inline-block ml-1" data-id="element-202">
              ⏳ {timeString}
            </span>
          </span>
          <span className="text-[11px] md:text-[13px] font-bold tracking-wide text-white/90" data-id="element-203">
            👉 Dejá de pagar técnicos — Resolvelo vos mismo desde hoy
          </span>
        </div>
      </a>
    </div>;
});